// extracted by css-extract-rspack-plugin
export default {"btnContainer":"dRR0z_Bxcv4y2FF9__btnContainer___","editFrom":"E0v7gdoWiaMN90ZB__editFrom___","externalLink":"gDqBfcdhWrwBKGTB__externalLink___"};